























































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import store from "@/store";
import { UserModel } from "@/models/usermodel";
import { mapGetters } from "vuex";
import { AppMutation } from "@/store/app/types";
import { allQuestionRepository } from "@/repositories/questionrpository";
import { QuestionCategory } from "@/global/interfaces";
import { QuestionCategoryMutation } from "@/store/questions/types";
import MenuIconSvg from "@/assets/img/icons/MenuIcon.vue";

@Component({
  components: {
    MenuIconSvg,
  },
  computed: {
    ...mapGetters({
      isNavExpanded: "isNavExpanded",
      user: "getUserProfile",
    }),
  },
})
export default class NavigationBar extends Vue {
  public user: UserModel;
  public isNavExpanded: boolean;
  public questionCategories: QuestionCategory[] = [];

  public items = [
    {
      title: this.$t("components.navigation_bar.labels.project"),
      icon: "project",
      redirect: "#project",
    },
    {
      title: this.$t("components.navigation_bar.labels.satisfaction_rate"),
      icon: "rate",
      redirect: "#satisfaction-rate",
    },
    {
      title: this.$t("components.navigation_bar.labels.question"),
      icon: "question",
      redirect: "#question",
    },
  ];

  public async created() {
    if (this.user?.cssId) {
      this.questionCategories =
        await allQuestionRepository.getQuestionCategories(
          this.user.cssId.toString(),
        );
      store.commit(
        QuestionCategoryMutation.SET_QUESTION_CATEGORIES,
        this.questionCategories,
      );
    }
  }

  public redirectPage(url: string) {
    if (this.$route.name === url) {
      return;
    }
    this.$router.push({ name: url });
  }

  public handleExpand() {
    store.commit(AppMutation.CHANGE_NAV_EXPAND, !this.isNavExpanded);
  }

  public generateCategoryIcon(category: QuestionCategory) {
    switch (category.icon) {
      case "general":
        return require("@/assets/img/icons/general.svg");
      case "project_quality":
        return require("@/assets/img/icons/project_quality.svg");
      case "change_request":
        return require("@/assets/img/icons/change_request.svg");
      case "project_management":
        return require("@/assets/img/icons/project_manager.svg");
      case "brse":
        return require("@/assets/img/icons/brse.svg");
    }
  }
}
